import React, { useState } from "react";

import styled from "styled-components";

import { ButtonLink } from "~/components/Button";
import * as DetailList from "~/components/DetailList";
import { Box, Content, Padding, Section, Separator } from "~/components/Elements";
import * as Grid from "~/components/Grid";
import TRMIcon from "~/components/icons/TRM";
import * as ModalDeprecated from "~/components/ModalDeprecated";
import Skeleton from "~/components/Skeleton";
import { Paragraph, Text, Title } from "~/components/Text";
import { VASP } from "~/types/vaspid";
import sleep from "~/utils/sleep";

const TRMStyledIcon = styled(TRMIcon)`
  zoom: 0.8;
`;

export default function VASPBlockchainActivity({ vasp }: { vasp?: VASP | null }) {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const hasTRM = true;

  async function handleOpen() {
    setLoading(true);
    await sleep(2000);
    setLoading(false);
    setShowModal(true);
  }
  function handleClose() {
    setShowModal(false);
  }

  return (
    <DetailList.Content>
      <ModalDeprecated.Container active={showModal}>
        <ModalDeprecated.Background onClick={handleClose} />

        <ModalDeprecated.Card sized="small">
          <ModalDeprecated.CardHead>
            <Grid.Container>
              <Title as="h1" align="centered">
                Your request has been successfully sent
              </Title>
              <Text as="p" align="centered">
                TRM has received your request. You will receive a report via email within 24 hours.
              </Text>
            </Grid.Container>
          </ModalDeprecated.CardHead>
          <ModalDeprecated.CardBody empty />
          <ModalDeprecated.CardFooter>
            <Grid.Container>
              <Grid.Columns multiline={false} align="right">
                <Grid.Column narrow>
                  <ButtonLink color="grey-dark" onClick={handleClose}>
                    Go to dashboard
                  </ButtonLink>
                </Grid.Column>
              </Grid.Columns>
            </Grid.Container>
          </ModalDeprecated.CardFooter>
        </ModalDeprecated.Card>
      </ModalDeprecated.Container>

      <Box as={Section}>
        <Padding sized="medium">
          <DetailList.Header>
            <DetailList.Item mobile={12}>
              <DetailList.Title as="h2">Blockchain activity</DetailList.Title>
            </DetailList.Item>
          </DetailList.Header>
          <Content>
            {vasp ? (
              <Paragraph>Get a comprehensive view of {vasp.name} on-chain activity.</Paragraph>
            ) : (
              <Skeleton count={1} />
            )}
          </Content>
          <Grid.Columns multiline>
            <Grid.Column narrow>
              <Box>
                <Padding sized="normal">
                  <Title size={5} as="h5" marginless>
                    <TRMStyledIcon /> TRM
                  </Title>
                  <Text color="black" weight="bolder" size={7}>
                    On-chain Risk Report
                  </Text>
                </Padding>
                <Separator sized={null} weight="bolder" color="info" />
                <Padding sized="normal" style={{ paddingBottom: "0.75rem" }}>
                  <Content sized="small">
                    <Paragraph transform="uppercase" weight="bold" color="grey">{`What's included`}</Paragraph>
                    <ul>
                      <li>TRM Risk Score</li>
                      <li>Risk indicators</li>
                      <li>Estimated counter-party flows</li>
                    </ul>
                    {hasTRM && (
                      <ButtonLink
                        fullwidth
                        align="centered"
                        sized="small"
                        kind={isLoading ? "dark" : "text"}
                        onClick={handleOpen}
                        disabled={isLoading}
                        loading={isLoading}
                      >
                        Request
                      </ButtonLink>
                    )}
                  </Content>
                </Padding>
              </Box>
            </Grid.Column>
          </Grid.Columns>
        </Padding>
      </Box>
    </DetailList.Content>
  );
}
